import styled, { keyframes } from 'styled-components';
const open = keyframes(["0%{border-radius:20px 20px 0 0;transform:translateY(100%);opacity:0;}40%{border-radius:20px 20px 0 0;transform:translateY(100%);opacity:0;}100%{border-radius:0;transform:translateY(0);opacity:1;}"]);
const close = keyframes(["0%{border-radius:0;transform:translateY(0);opacity:1;}20%{border-radius:0;opacity:1;}80%{border-radius:20px 20px 0 0;transform:translateY(100%);opacity:0;}100%{border-radius:20px 20px 0 0;transform:translateY(100%);opacity:0;}"]);
const StyledOperationsHubOnboardingModal = styled.section.withConfig({
  displayName: "StyledOperationsHubOnboardingModal",
  componentId: "sc-8eciiz-0"
})(["display:flex;flex-direction:column;background-color:", ";border:1px solid ", ";width:525px;min-height:217px;position:fixed;bottom:16px;z-index:900;overflow:hidden;pointer-events:", ";animation:", " 300ms ease-out;"], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => theme.color['do-not-use-great-white'], ({
  isOpen
}) => isOpen ? 'all' : 'none', ({
  isOpen
}) => isOpen ? open : close);
export default StyledOperationsHubOnboardingModal;